import React from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./SuccessInvitedToTicket.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List } from "../../../../components";
import Link from "next/link";
import { StyledBlueSpan } from "../Success/Success.styles";

/**
 * "emailOffer" is the standard invitation, valid for hours or days.
 * "lastMinOffer" is the consolidated flow's last-min path: applying inside the last-min
 * phase can hand out a seat immediately, by SMS, with minutes on the clock — so the copy
 * cannot talk about inboxes and cannot imply there is time to spare.
 */
export type InvitedSuccessVariant = "emailOffer" | "lastMinOffer";

interface SuccessProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
  variant?: InvitedSuccessVariant;
}

const Success: React.FC<SuccessProps> = ({
  firstName,
  bookingInterestId,
  variant = "emailOffer",
}) => {
  const router = useRouter();
  const isLastMin = variant === "lastMinOffer";

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-cy-variant={variant}
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
          <Logo />
        </SuccessImage>
        <Title>
          Congratulations {firstName}!
        </Title>
      </TitleContainer>
      <ContentContainer>
        <SubTitle>
          {isLastMin
            ? "A last minute seat just opened up for you!"
            : "You’ve already been Invited to receive Tickets!"}
        </SubTitle>
        <List elements={isLastMin ? [
          <>This is a last minute offer, so the clock is already running - confirm now, before the seat goes to the next person in the queue.</>,
          <>We have also texted you the link. Confirming is one step: it accepts the ticket and checks you in at the same time.</>,
          <>You can always find this booking in your profile under
          <Link href="/profile?tab=tickets"><StyledBlueSpan> Applications & Tickets </StyledBlueSpan></Link>.</>
        ] : [
          <>The countdown has begun! Accept your ticket (and any dependant’s tickets) now before time runs out.</>,
          <>Any guests in your booking will have a ticket offer too! Shoot them a text and ask them to check their inbox (and SPAM/Promotions folder) pronto.</>,
          <>If your guests still can’t see the email, check and change their email address in your profile under
          <Link href="/profile?tab=tickets"><StyledBlueSpan> Applications & Tickets </StyledBlueSpan></Link> - Manage My Booking.</>
        ]} />
      </ContentContainer>
      <CTAContainer>
        <Button data-cy="accept-ticket-now-button" onClick={() => router.push('/profile')}>
          {isLastMin ? "CONFIRM YOUR SEAT NOW!" : "ACCEPT YOUR TICKET NOW!"}
        </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(Success);
